import React from 'react';

/**
 * Props para um elemento clicável que NÃO é `<button>` (span/div estilizados):
 * papel de botão, foco por Tab e ativação por Enter/Espaço (out/2026, revisão
 * de UX — ~31 elementos clicáveis não eram alcançáveis por teclado nem
 * anunciados pelo leitor de tela). Componente novo usa `<button>` de verdade;
 * isto é para os que trocar a tag mudaria o layout.
 */
export const clickable = (
  onActivate: () => void,
  label?: string
): React.HTMLAttributes<HTMLElement> => ({
  role: 'button',
  tabIndex: 0,
  onClick: onActivate,
  onKeyDown: (e: React.KeyboardEvent<HTMLElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onActivate();
    }
  },
  ...(label ? { 'aria-label': label, title: label } : {}),
});
